<template>
	<div class="connect_bg">
		<div
			:class="{
				connect_wrap: true,
			}"
		>
			<div class="connect_close_btn" @click="close"></div>
			<div class="connecting_wrap">
				<div class="connecting_error_title">您的NAS无法正常访问</div>
				<div class="sub-tips">HTTP/HTTPS配置可能存在冲突</div>
				<div class="sub-tips2">请按照指引修改配置</div>
				<div class="select-wrap">
					<div class="firm-item" @click="showQhHelp">
						<div class="firm-icon">
							<div class="firm-icon2"></div>
						</div>
						<div class="firm-text">群晖</div>
						<div class="firm-icon3"></div>
						<div class="firm-text2">Synology</div>
					</div>
					<div class="firm-item firm-item2" @click="showWltHelp">
						<div class="firm-icon">
							<div class="firm-icon2"></div>
						</div>
						<div class="firm-text">威联通</div>
						<div class="firm-icon3"></div>
						<div class="firm-text2">QNAP</div>
					</div>
					<div class="firm-item firm-item3" @click="showTwmHelp">
						<div class="firm-icon">
							<div class="firm-icon2"></div>
						</div>
						<div class="firm-text">铁威马</div>
						<div class="firm-icon3"></div>
						<div class="firm-text2">TerraMaster</div>
					</div>
				</div>
				<div class="sure-btn" @click="close">确定</div>
				<!-- <div class="connecting_tips">
					<p class="title">我们提供如下解决方案</p>
					<p class="sub-title">如您是http访问:</p>
					<p>
						DSM_6：前往NAS控制面板->网络->DSM->取消勾选HTTP自动导向HTTPS
					</p>
					<p>
						DSM_7：前往NAS控制面板->登录门户>DSM->取消勾选HTTP自动导向HTTPS
					</p>
					<p class="sub-title">如您是https访问：</p>
					<p>
						请前往节点小宝高级功能，手动添加您自定义的https端口（默认5001）
					</p>
				</div> -->
			</div>
		</div>
		<div class="connect_wrap help-wrap" v-if="isShowQhHelp">
			<div class="connect_close_btn" @click="closeQhHelp"></div>
			<div class="title">群晖访问配置</div>
			<div class="content-wrap">
				<div class="sub-title">推荐配置:</div>
				<div class="sub-sub-title">DSM_6:</div>
				<div class="sub-content">
					前往NAS控制面板->网络->DSM->取消勾选HTTP自动导向HTTPS
				</div>
				<div class="sub-sub-title">DSM_7:</div>
				<div class="sub-content">
					前往NAS控制面板->登录门户>DSM->取消勾选HTTP自动导向HTTPS
				</div>
				<div class="sub-title2">如您需要HTTPS访问:</div>
				<div class="sub-content">
					请前往节点小宝高级功能，手动添加您自定义的https端口（默认5001）
				</div>
			</div>
			<div class="sure-btn" @click="closeQhHelp">确定</div>
		</div>
		<div class="connect_wrap help-wrap" v-if="isShowWltHelp">
			<div class="connect_close_btn" @click="closeWltHelp"></div>
			<div class="title">威联通访问配置</div>
			<div class="content-wrap">
				<div class="sub-title">推荐配置:</div>
				<div class="sub-content">
					前往NAS控制台->系统->常规设置->配置HTTP端口，并取消勾选“强制使用HTTPS访问”
				</div>
				<div class="sub-title2">如您需要HTTPS访问:</div>
				<div class="sub-content">
					请前往节点小宝高级功能，手动添加您自定义的HTTPS端口
				</div>
			</div>
			<div class="sure-btn" @click="closeWltHelp">确定</div>
		</div>
		<div class="connect_wrap help-wrap" v-if="isShowTwmHelp">
			<div class="connect_close_btn" @click="closeTwmHelp"></div>
			<div class="title">铁威马访问配置</div>
			<div class="content-wrap">
				<div class="sub-title">推荐配置:</div>
				<div class="sub-sub-title">TOS4:</div>
				<div class="sub-content">
					前往NAS控制面板->网络设置->配置HTTP端口
				</div>
				<div class="sub-sub-title">TOS5:</div>
				<div class="sub-content">
					前往NAS控制面板->网络->取消勾选“强制HTTP重定向到HTTPS”
				</div>
			</div>
			<div class="sure-btn" @click="closeTwmHelp">确定</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			isShowQhHelp: false,
			isShowTwmHelp: false,
			isShowWltHelp: false,
		};
	},
	props: [],
	methods: {
		closeQhHelp: function () {
			this.isShowQhHelp = false;
		},
		closeTwmHelp: function () {
			this.isShowTwmHelp = false;
		},
		closeWltHelp: function () {
			this.isShowWltHelp = false;
		},
		showQhHelp: function () {
			this.isShowQhHelp = true;
		},
		showTwmHelp: function () {
			this.isShowTwmHelp = true;
		},
		showWltHelp: function () {
			this.isShowWltHelp = true;
		},
		close: function () {
			let _that = this;
			_that.$emit("close");
		},
	},
	watch: {},
	mounted() {},
};
</script>

<style lang="less" scoped>
.connect_bg {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.1);
	z-index: 9;
	.connect_wrap {
		width: 460px;
		height: 330px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-top: -165px;
		margin-left: -230px;
		background-color: #f5f5f5;
		background-image: linear-gradient(180deg, #f4f7ff 0%, #ffffff 19.79%);
		border-radius: 5px;
		box-shadow: 0px 0px 14px 2px #999999;

		.connect_close_btn {
			width: 20px;
			height: 20px;
			position: absolute;
			right: 20px;
			top: 14px;
			cursor: pointer;
			background-image: url(../../assets/common/close2.svg);
			background-size: 100% 100%;
		}
		.connecting_icon {
			width: 200px;
			height: 130px;
			background-image: url(../../assets/home/node/connecting_icon.svg);
			background-size: 100% auto;
			margin: 25px auto 15px auto;
		}
		.connecting_icon_failed {
			background-image: url(../../assets/home/node/connect_failed_icon.svg);
		}
		.connecting_error_title {
			color: #143977;
			font-weight: 600;
			font-size: 20px;
			line-height: 28px;
			text-align: center;
			margin-top: 28px;
			margin-bottom: 8px;
		}
		.sub-tips {
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;
			text-align: center;
			color: #9c9c9c;
		}
		.sub-tips2 {
			font-weight: 400;
			font-size: 14px;
			line-height: 24px;
			color: #666666;
			text-align: center;
			margin-top: 15px;
		}
		.connecting_title {
			font-size: 14px;
			color: #666666;
			font-weight: bolder;
			text-align: center;
			margin-top: 10px;
		}
		.connecting_name {
			color: #1f5de3;
			font-size: 16px;
			text-align: center;
			margin-bottom: 15px;
			font-weight: bolder;
		}
		.connecting_tips {
			color: #666666;
			font-size: 12px;
			text-align: left;
			margin: 0 auto;
			margin-top: 3px;
			width: 80%;
			.title {
				font-size: 14px;
				font-weight: bolder;
				margin-bottom: 4px;
			}
			.sub-title {
				font-size: 13px;
				font-weight: bolder;
				margin-bottom: 4px;
				margin-top: 6px;
			}
			span {
				color: #1f5de3;
				margin-left: 5px;
				cursor: pointer;
			}
		}
		.connecting_channel {
			width: 330px;
			height: 42px;
			background-color: #5187fd;
			background-image: linear-gradient(to right, #1f5de3, #5187fd);
			color: #c5f1ff;
			line-height: 42px;
			text-align: center;
			border-radius: 21px;
			margin: 0 auto;
			font-size: 13px;
			.connecting_channel_left {
				display: inline-block;
				vertical-align: top;
				width: 42px;
				height: 42px;
				line-height: 42px;
				background-image: url(../../assets/home/node/connect_channel_left.png);
				background-repeat: no-repeat;
				background-position: center center;
				background-size: 32px 20px;
				margin-right: 20px;
			}
			.connecting_channel_name {
				display: inline-block;
				vertical-align: top;
				height: 42px;
				line-height: 42px;
			}
			.connecting_channel_right {
				display: inline-block;
				vertical-align: top;
				height: 42px;
				width: 42px;
				line-height: 42px;
				background-image: url(../../assets/home/node/connect_channel_right.png);
				background-repeat: no-repeat;
				background-position: center center;
				background-size: 32px 20px;
				margin-left: 20px;
			}
		}
	}
	.connect_wrap.connect_vip_wrap {
		.connecting_channel {
			background-image: linear-gradient(to right, #f2d7b3, #d9ad84);
			.connecting_channel_left {
				background-image: url(../../assets/home/node/connect_channel_vip_left.png);
			}
			.connecting_channel_name {
				color: #795c24;
				font-weight: bolder;
				font-size: 14px;
			}
			.connecting_channel_right {
				background-image: url(../../assets/home/node/connect_channel_vip_right.png);
			}
		}
		.connecting_title {
			color: #795c24;
		}
	}
}

.select-wrap {
	text-align: center;
	margin-top: 10px;

	.firm-item {
		display: inline-block;

		vertical-align: top;
		width: 100px;
		height: 122px;
		box-sizing: border-box;
		border: 1px solid transparent;
		border-radius: 4px;
		cursor: pointer;
		background-color: #f3f9ff;
		border: 1px solid #ffffff;
		.firm-icon {
			position: relative;
			width: 98px;
			height: 48px;
			// background: #f3f9ff;
			// border: 1px solid rgba(22, 59, 122, 0.02);
			border-radius: 4px;
			box-sizing: border-box;
			.firm-icon2 {
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
				width: 66px;
				height: 17px;
				background-image: url("../../assets/remote/download1.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
		}
		.firm-text {
			margin-top: 12px;
			font-weight: 600;
			font-size: 16px;
			line-height: 22px;
			text-align: center;
			color: #666666;
		}
		.firm-icon3 {
			margin: 0 auto;
			margin-top: 4px;
			width: 16px;
			height: 2px;
			background-color: #999999;
			border-radius: 1px;
		}
		.firm-text2 {
			margin-top: 4px;
			font-size: 14px;
			line-height: 20px;
			text-align: center;
			color: #999999;
		}
	}
	.firm-item:hover {
		// padding-top: 2px;
		border: 1px solid rgba(22, 59, 122, 0.6);
		box-shadow: 0px 4px 6px rgba(108, 121, 141, 0.2);
		background-color: #f3f9ff;
		.firm-icon {
			border: 1px solid transparent;
			background-color: #f3f9ff;
		}
		.firm-text {
			color: #163b7a;
		}
		.firm-icon3 {
			background-color: #163b7a;
		}
	}
	.firm-item2 {
		margin-left: 12px;
		.firm-icon {
			.firm-icon2 {
				width: 64px;
				height: 10px;
				background-image: url("../../assets/remote/download18.png");
			}
		}
	}
	.firm-item3 {
		margin-left: 12px;
		.firm-icon {
			.firm-icon2 {
				width: 64px;
				height: 30px;
				background-image: url("../../assets/remote/download19.png");
			}
		}
	}
	.firm-item4 {
		margin-left: 12px;
		.firm-icon {
			.firm-icon2 {
				width: 67px;
				height: 13px;
				background-image: url("../../assets/remote/download20.png");
			}
		}
	}
	.firm-item5 {
		margin-left: 12px;
		.firm-icon {
			.firm-icon2 {
				width: 68px;
				height: 9px;
				background-image: url("../../assets/remote/download23.png");
			}
		}
	}
}
.sure-btn {
	margin: 0 auto;
	margin-top: 20px;
	width: 125px;
	height: 42px;
	background-color: #243a5e;
	background-image: linear-gradient(
		157.05deg,
		#243a5e 19.08%,
		#1c2f4d 90.93%
	);
	border-radius: 126px;
	text-align: center;
	font-weight: 400;
	font-size: 14px;
	line-height: 42px;
	color: #ffffff;
}

.sure-btn:hover {
	cursor: pointer;
	opacity: 0.9;
}

.connect_wrap.help-wrap {
	width: 520px;
	margin-left: -260px;
	z-index: 10;
	.title {
		font-weight: 600;
		font-size: 20px;
		line-height: 28px;
		text-align: center;
		color: #143977;
		margin-top: 20px;
	}
	.content-wrap {
		width: 450px;
		margin: 0 auto;
		margin-top: 35px;
		.sub-title {
			font-style: normal;
			font-weight: 600;
			font-size: 16px;
			line-height: 22px;

			color: #000000;
			margin-top: 20px;
		}

		.sub-title2 {
			font-style: normal;
			font-weight: 600;
			font-size: 14px;
			line-height: 22px;

			color: #000000;
			margin-top: 20px;
		}
		.sub-sub-title {
			font-style: normal;
			font-weight: 600;
			font-size: 14px;
			line-height: 20px;

			color: #4277ff;
		}
		.sub-content {
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;

			color: #000000;
		}
	}
}
</style>